import { ReactNode } from 'react';
import { AuthenticationGuard } from '@auth/AuthenticationGuard';
import AppRetiredPage from '@pages/AppRetiredPage';
import PageLoadProgress from '@shared/components/PageLoadProgress';
import { useUserContext } from '@shared/contexts/UserContextProvider';
import { checkHasLegacyAppAccess } from '@utils/permissions';

interface Props {
  children: ReactNode;
}

/**
 * Flux 3.0 is retired for everyone except admins. Users without legacy access get the retirement notice
 * instead of the app. Until the user is loaded, the authentication guard still redirects anonymous visitors to login.
 */
export const LegacyAppAccessGate = ({ children }: Props) => {
  const user = useUserContext();

  if (!user) {
    return <AuthenticationGuard component={PageLoadProgress} />;
  }

  if (!checkHasLegacyAppAccess(user)) {
    return <AppRetiredPage />;
  }

  return <>{children}</>;
};
